module.exports = __webpack_public_path__ + "media/images/sports_icons/011-karate-6326a3b96ccc4c2f3b72cf47f9e17ab1.png";